import {useMemo} from 'react'
import {
    TreatmentRequestDetailsGroup,
    useTreatmentRequestDetailsStore
} from '@/features/treatment-requests/store/treatmentRequestDetailsStore'

export const useTreatmentRequestEditModeView = (fieldsGroup: TreatmentRequestDetailsGroup) => {
    const currentEditingFieldsGroup = useTreatmentRequestDetailsStore(state => state.editingFieldsGroup)
    const isEditModeEnabled = useMemo(() => currentEditingFieldsGroup == fieldsGroup, [currentEditingFieldsGroup])
    const isDisabledView = useMemo(
        () => !!currentEditingFieldsGroup && !isEditModeEnabled,
        [currentEditingFieldsGroup, isEditModeEnabled]
    )

    return {
        isEditModeEnabled,
        isDisabledView
    }
}
